import PropTypes from 'prop-types'
import React, {Component} from 'react'
import {Button, Container, Embed, Grid, Header, Icon, Segment,} from 'semantic-ui-react'
import Thumbnail from "../assets/images/thumb.jpg";
import {Translate} from "react-localize-redux";
import MailingListForm from "./mailinglist/MailingListForm";

/* eslint-disable react/no-multi-comp */
class HomepageHeading extends Component {
  static propTypes = {
    mobile: PropTypes.bool.isRequired
  };

  render() {
    let spotifyText = this.props.mobile ? '' : 'Spotify';
    let iTunesText = this.props.mobile ? '' : 'iTunes';
    let googlePlayText = this.props.mobile ? '' : 'Google Play';
    let facebookText = this.props.mobile ? '' : 'Facebook';
    let twitterText = this.props.mobile ? '' : 'Twitter';
    let instagramText = this.props.mobile ? '' : 'Instagram';
    let soundcloudText = this.props.mobile ? '' : 'SoundCloud';
    let youtubeText = this.props.mobile ? '' : 'YouTube';

    return (
      <Segment style={{padding: this.props.mobile ? '0em' : '8em'}} inverted vertical>
        <Grid container stackable verticalAlign='middle'>
          <Grid.Row>
            <Grid.Column textAlign='center'>
              <Header
                as='h1'
                content={<Translate id="latentSignal"/>}
                inverted
                style={{
                  fontSize: this.props.mobile ? '5em' : '5em',
                  fontWeight: 'normal',
                  marginTop: this.props.mobile ? '0.4em' : '0em',
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid container divided='vertically' stackable inverted verticalAlign='middle'>
          <Grid.Row centered>
            <Grid.Column width={14} >
              <Button.Group widths='3'>
                <Button color='spotify' href={"https://open.spotify.com/artist/2yMSEhkGq1uUFAIcaSBTfs"} style={{borderBottomLeftRadius: 0}}>
                  <Icon name='spotify'/> {spotifyText}
                </Button>
                <Button color='itunes' href={"https://itunes.apple.com/us/artist/latent-signal/1403709614"}>
                  <Icon name='itunes'/> {iTunesText}
                </Button>
                <Button color='google' href={"https://play.google.com/music/m/Ab2zr5y2obkytl2zxxge24rgwnm?t=Latent_Signal"} style={{borderBottomRightRadius: 0}}>
                  <Icon name='google'/> {googlePlayText}
                </Button>
              </Button.Group>

              <Embed id='Jl5FGYOQuSE'
                     source='youtube'
                     placeholder={Thumbnail} />

              <Button.Group widths='6'>
                <Button color='facebook' href={"https://www.facebook.com/latentsignal/"} style={{borderTopLeftRadius: 0}}>
                  <Icon name='facebook'/> {facebookText}
                </Button>
                <Button color='twitter' href={"https://twitter.com/latentsignal"}>
                  <Icon name='twitter'/> {twitterText}
                </Button>
                <Button color='instagram' href={"https://www.instagram.com/latentsignal"}>
                  <Icon name='instagram'/> {instagramText}
                </Button>
                <Button color='soundcloud' href={"https://soundcloud.com/latentsignal"}>
                  <Icon name='soundcloud'/> {soundcloudText}
                </Button>
                <Button color='youtube' href={"https://www.youtube.com/channel/UCqQdwJ5W-FDAin_Hc6oHz_A"} style={{borderTopRightRadius: 0}}>
                  <Icon name='youtube'/> {youtubeText}
                </Button>
              </Button.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid stackable divided='horizontally' inverted>
          <Grid.Row centered>
            <Grid.Column textAlign={this.props.mobile ? 'center' : 'right'} width={7}>
              <Header inverted as='h3'><Translate id='mailingList.title'/></Header>
              <Translate id='mailingList.subtitle'/>
            </Grid.Column>
            {/* This wrapping column is causing problems. Figure out how to fix it.*/}
            <Grid.Column floated={this.props.mobile ? null : 'left'} width={this.props.mobile ? 1 : 5}>
              <MailingListForm mobile={this.props.mobile}/>
            </Grid.Column>
          </Grid.Row>
        </Grid>

      </Segment>
    )
  }
}

export default HomepageHeading



// WEBPACK FOOTER //
// ./src/components/HomepageHeading.js